//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        questions: Array,
        show: Boolean,
        lazy_load: Boolean,
        btn_style: Object,
        dlg_style: Object,
        className: {
            type: String,
            default: 'wrap'
        }
    },
    data () {
        return {
            fold: true
        }
    },
    methods: {
        toggleFold () {
            if (this.lazy_load && !this.questions.length) {
                this.$emit('getQuestions')
            }
            this.fold = !this.fold
        },
        select ({ id, content, style, jump_link }, index) {
            console.error(jump_link, style)
            if (jump_link && style) {
                let url
                if (style === 'wx_app_path') {
                    url = jump_link
                } else if (style === 'link') {
                    url = `/web_page?link=${encodeURIComponent(jump_link)}&title=`
                }
                wx.navigateTo({
                    url
                })
            } else {
                this.$emit('onSelect', id)
            }
            this.toggleFold()
            const pages = getCurrentPages()
            const page = pages[pages.length - 1]
            this.$sendCtmEvtLog(`列表页面提问咨询--${content}点击`, {
                id,
                index,
                content,
                path: page && page.route
            })
        }
    }
}
